import { createI18n, useI18n as useVueI18n } from "vue-i18n";

const localeModules = import.meta.glob<{ default: Record<string, any> }>(
    "../generated/locales/*.json",
    { eager: true },
);

const messages: Record<string, Record<string, any>> = {};

for (const path in localeModules) {
    const match = path.match(/([a-z]{2}(?:-[A-Z]{2})?)\.json$/);
    if (!match) continue;
    messages[match[1]] = localeModules[path].default;
}

export const i18n = createI18n<{}, string, false>({
    legacy: false,
    locale: 'cs',
    fallbackLocale: 'cs',
    messages,
});

export const useI18n = () => useVueI18n();
